import { isBadOrEmptyString } from '../../../../predicates/string';
import { isUndefined } from '../../../../predicates/type';

interface GetPartiallyRequiredFilledProp {
	(props: { partiallyRequiredFilled?: boolean; value?: unknown }): boolean;
}

export const getPartiallyRequiredFilledProp: GetPartiallyRequiredFilledProp = ({ partiallyRequiredFilled, value }) => {
	const hasValue = !isBadOrEmptyString(value);

	return isUndefined(partiallyRequiredFilled) ? hasValue : partiallyRequiredFilled && hasValue;
};

interface GetPreviewModeProp {
	(props: { metadataPreviewMode?: boolean; previewMode?: boolean }): boolean;
}

export const getPreviewModeProp: GetPreviewModeProp = ({ metadataPreviewMode, previewMode }) => {
	return !!(metadataPreviewMode || previewMode);
};
